import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Table,
} from "reactstrap";
import swal from "sweetalert2";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
const animatedComponents = makeAnimated();

const ItemEditOrders = (props) => {
  const { SearchBar } = Search;
  const [editModal, setEditModal] = useState();
  const [remarks, setRemarks] = useState();
  useEffect(() => {
    loadAllBranches();
    loadAllCategories();
  }, []);
  const [confirmClose, setConfirmClose] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    loadAllOrders();
  }, [selectedCategory, selectedBranch]);

  const [allOrders, setAllOrders] = useState([]);
  const loadAllOrders = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "itemorders/getall";
    const response = await postSubmitForm(url, {
      status: [
        "Approved",
        // "Dispatched",
        // "Partially Dispatched",
        // "Delivered",
        // "Partially Received",
      ],
      branch: selectedBranch,
      category: selectedCategory,
    });
    if (response && response.status === 1) {
      preloader(false);
      setAllOrders(response.data);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  const refForForm = useRef(null);
  const refSelectItem = useRef(null);
  const [itemsForOrder, setItemsForOrder] = useState([]);
  const handleAddItemForOrder = async (e, v) => {
    var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem._id;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item is already added."),
        props.t("Error")
      );
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem._id;
      item_to_add.name = selectedItem.name;
      item_to_add.category = selectedItem.category;
      item_to_add.sub_category = selectedItem.sub_category;
      item_to_add.brand = selectedItem.brand;
      item_to_add.unit = selectedItem.unit;
      if (selectedItem.sub_unit) {
        item_to_add.sub_unit = selectedItem.sub_unit;
      }
      item_to_add.formula = selectedItem.formula;
      item_to_add.available = selectedItem.available;
      item_to_add.quantity = selectedItem.sub_unit
        ? { in_unit: v.in_unit, in_sub_unit: v.in_sub_unit }
        : { in_unit: v.quantity, in_sub_unit: 0 };
      setItemsForOrder([...itemsForOrder, item_to_add]);
      refSelectItem.current.select.clearValue();
      refForForm.current.reset();
    } else {
      showNotification(props.t("Select an item first."), props.t("Error"));
    }
  };

  const [isUrgent, setIsUrgent] = useState(false);
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedOrder._id,
        item_details: itemsForOrder,
        //is_urgent: isUrgent,
        remarks: v.remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "itemorders/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllOrders();
        setEditModal(!editModal);
        setRemarks();
        setItemsForOrder([]);
        setIsUrgent(false);
        setSelectedItem();
        refSelectItem.current.select.clearValue();
        refForForm.current.reset();

        showNotification(response.message, "Success");

        refForForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };
  const [allBranches, setAllBranches] = useState([]);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type === "Branch")
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedOrder, setSelectedOrder] = useState();
  const handleCloseOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/set_closed";
    const response = await postSubmitForm(url, {
      itemorder_id: selectedOrder._id,
      admin_remarks: adminRemarks,
    });

    if (response && response.status === 1) {
      setAdminRemarks("");
      loadAllOrders();
      setRemarksModal(!remarksModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [remarksModal, setRemarksModal] = useState();
  const [adminRemarks, setAdminRemarks] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),

      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },
    {
      text: props.t("Order Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      dataField: "createdAt",
      // formatter: (cell, row) => {
      //   return moment(row.createdAt).format("DD-MM-YYYY HH:mm");
      // },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
         
            <button
              class="btn btn-info btn-sm mr-2"
              onClick={() => {
                setEditModal(!editModal);
                loadItemsInOrder(row._id);
                setItemsForOrder(row.item_details);
                setSelectedOrder(row);
              }}
            >
              {props.t("Edit")}
            </button>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
  ];

  //#region Dispatch order related code
  const [selectedItem, setSelectedItem] = useState();
  const [allItems, setAllItems] = useState([]);
  const loadItemsInOrder = async (itemorder_id) => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/get_items_in_order";

    const response = await postSubmitForm(url, { itemorder_id });

    if (response && response.status === 1) {
      setAllItems(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  function deleteFormatter_edit(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.item_id !== row.item_id
              );

              setItemsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }

  const columns_items_edit = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter_edit,
      formatExtraData: itemsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedRowsUnit([])
  }

  const handleCheckboxChange = (index) => {
    const updatedRows = [...selectedRowsUnit];
    const existingIndex = updatedRows.findIndex((row) => row.index === index);

    if (existingIndex !== -1) {
      updatedRows[existingIndex].isChecked = !updatedRows[existingIndex].isChecked;
      if (!updatedRows[existingIndex].isChecked) {
        updatedRows.splice(existingIndex, 1,);
      }
    } else {
      updatedRows.push({
        index,
        unit: selectedItem.unit_levels[index].unit,
        value: 0,
        isChecked: true,
      });
    }
    setSelectedRowsUnit(updatedRows);
  };

  const handleQuantityChange = (index, quantity) => {
    const updatedRows = [...selectedRowsUnit];
    const existingIndex = updatedRows.findIndex((row) => row.index === index);
    if (existingIndex !== -1 && updatedRows[existingIndex].isChecked) {
      updatedRows[existingIndex].value = quantity;
    }
    setSelectedRowsUnit(updatedRows);
  }

  const handleAddUnits = async (e, v) => {
    var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem._id;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item is already added."),
        props.t("Error")
      );
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem?.item_id;
      item_to_add.name = selectedItem.name;
      item_to_add.category = selectedItem.category;
      item_to_add.sub_category = selectedItem.sub_category;
      item_to_add.brand = selectedItem.brand;
      item_to_add.available = selectedItem.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.quantity = selectedRowsUnit.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem.unit_levels.map(({ unit, value }) => ({ unit, value }));
      item_to_add.expiry_date = selectedItem.expiry_date;
      item_to_add.cost_price = selectedItem.cost_price;
      item_to_add.selling_price = selectedItem.selling_price;
      setItemsForOrder([...itemsForOrder, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem();
      setSelectedRowsUnit([]);
      refSelectItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };

  //#endregion

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Central Store")}
            breadcrumbItem1={props.t("Item Order")}
            breadcrumbItem2={props.t("Edit Orders")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Edit Orders")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("Edit orders in process here")}
                  </CardSubtitle>

                  <ToolkitProvider
                    keyField="_id"
                    data={allOrders && allOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="branch"
                                label={props.t("Branch")}
                                type="select"
                                value={selectedBranch}
                                onChange={(e) => {
                                  setSelectedBranch(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allBranches &&
                                  allBranches.map((branch) => {
                                    return (
                                      <option value={branch._id}>
                                        {branch.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="category"
                                label={props.t("Category")}
                                type="select"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allCategories &&
                                  allCategories.map((category) => {
                                    return (
                                      <option value={category.category}>
                                        {category.category}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          {...props_table.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>

                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleCloseOrder();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you close this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}

                  {/* Edit Modal starts */}
                  <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update Order")}
                    </ModalHeader>
                    <ModalBody>
                      {selectedOrder && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm
                                    onValidSubmit={() => setSelectUnitModal(!selectUnitModal)}
                                    ref={refForForm}
                                  >
                                    <Row>
                                      <Col lg={5}>
                                        <Label>{props.t("Item")}</Label>
                                        <Select
                                          ref={refSelectItem}
                                          value={selectedItem}
                                          onChange={(selected) => {
                                            setSelectedItem(selected);
                                          }}
                                          options={allItems}
                                          classNamePrefix="select2-selection"
                                          components={animatedComponents}
                                          required
                                        />
                                      </Col>

                                      <Col lg={2} className="mb-4">
                                        <Label>&nbsp;</Label>
                                        <br />
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="btn btn-info waves-effect waves-light btn-sm"
                                        >
                                          <i class="bx bx-add-to-queue"></i>{" "}
                                          {props.t("Add")}
                                        </Button>
                                      </Col>
                                    </Row>
                                    {/* <Button type="submit">Submit</Button> */}
                                  </AvForm>
                                  <hr />
                                  {itemsForOrder && itemsForOrder.length > 0 && (
                                    <>
                                      <BootstrapTable
                                        bootstrap4
                                        keyField="_id"
                                        data={itemsForOrder && itemsForOrder}
                                        columns={columns_items_edit}
                                        noDataIndication="No data to display."
                                        striped
                                        hover
                                        condensed
                                      />
                                      <AvForm onValidSubmit={handleValidUpdate}>
                                        <Row>
                                          <Col lg={6}>
                                            <AvField
                                              name="remarks"
                                              value={remarks}
                                              onChange={(e) => {
                                                setRemarks(e.target.value);
                                              }}
                                              label={props.t("Remarks")}
                                              placeholder={props.t("Enter Remarks")}
                                              type="textarea"
                                            />
                                          </Col>
                                          
                                          <Col lg={12}>
                                            <hr />
                                            <FormGroup className="mb-0 text-left">
                                              <div>
                                                <Button
                                                  type="submit"
                                                  color="primary"
                                                  className="mr-1"
                                                >
                                                  {props.t("Update Order")}
                                                </Button>{" "}
                                              </div>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Edit Modal ends */}

                  {/* Add unit modal  */}
                  <Modal
                    size="md"
                    isOpen={selectUnitModal}
                    // toggle={() => setSelectUnitModal(!selectUnitModal)}
                    toggle={handleCloseModal}
                    onClosed={handleCloseModal}
                  >
                    <ModalHeader toggle={() => setSelectUnitModal(!selectUnitModal)}>
                      {props.t("Enter Quantity")}
                    </ModalHeader>
                    <ModalBody>
                      <AvForm onValidSubmit={() => { handleAddUnits() }}>

                        <Col lg={12}>
                          <Table bordered size="sm" responsive className="table table-sm">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>{props.t("Unit")}</th>
                                <th>{props.t("Quantity")}</th>
                                <th>{props.t("Formula")}</th>

                              </tr>
                            </thead>
                            <tbody>
                              {selectedItem?.unit_levels &&
                                selectedItem.unit_levels?.map((unitObj, index) => {
                                  let prevUnit = index;
                                  if (index == 0) {
                                    prevUnit = "NA";
                                  } else
                                    prevUnit =
                                      selectedItem?.unit_levels[index - 1].unit;
                                  return (
                                    <tr key={index} >
                                      <td>
                                        <div class="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value=""
                                            checked={selectedRowsUnit.some(
                                              (row) =>
                                                row.index === index && row.isChecked
                                            )}
                                            id={`flexCheckDefault_${index}`}
                                            onChange={() => handleCheckboxChange(index)}
                                          />
                                        </div>
                                      </td>
                                      <td onClick={() => handleCheckboxChange(index)}>
                                        {unitObj.unit}</td>
                                      <td>
                                        <AvField
                                          type="number"
                                          className="form-control"
                                          style={{ width: "60px", height: "20px" }}
                                          placeholder="0"
                                          name={unitObj.unit}
                                          validate={{
                                            required: {
                                              value: selectedRowsUnit?.some(
                                                (row) =>
                                                  row.index === index && row.isChecked
                                              )
                                                ? true
                                                : false,
                                            },
                                            min: {
                                              value: selectedRowsUnit?.some((row) => row.index === index && row.isChecked) ? 1 : 0,
                                              errorMessage: "Value must be greater than zero",
                                            },


                                          }}
                                          errorMessage={props.t("Qty. can't be empty")}
                                          disabled={!selectedRowsUnit.some((row) => row.index === index && row.isChecked)}
                                          value={
                                            selectedRowsUnit.find(
                                              (row) => row.index === index
                                            )?.value
                                          }
                                          onChange={(e) => {
                                            const quantity = e.target.value;
                                            handleQuantityChange(index, quantity);
                                          }}
                                        />
                                      </td>
                                      <td>
                                {index > 0
                                  ? "1" +
                                  "  " +
                                  prevUnit +
                                  " = " +
                                  unitObj.value +
                                  " " +
                                  unitObj.unit
                                  : "NA"}
                              </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Col>

                        <Row className="mt-3">
                          <Col lg={12}>
                            <FormGroup className="mb-0 text-center">
                              <div>
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="mr-1"
                                >
                                  {props.t("Add")}
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(ItemEditOrders)));
